import { render } from "./IndexExitDeclarationPage.vue?vue&type=template&id=31ddc248&scoped=true"
import script from "./IndexExitDeclarationPage.vue?vue&type=script&lang=js"
export * from "./IndexExitDeclarationPage.vue?vue&type=script&lang=js"

import "./IndexExitDeclarationPage.vue?vue&type=style&index=0&id=31ddc248&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ddc248"]])

export default __exports__